import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { getAndParseLocationCookie } from "lib/nekoCookies";
import { useConfig } from "render/context/ConfigContext";

const NekoLensSiteIds: string[] = ["THIS_SITE_DOES_NOT_EXIST"];
const NekoLensSupportedPatientGroups: string[] = [
  "fcacd5b9-631e-47d4-9aa7-e953fbf9a0ba", // PatientGroup-ProdTesting-0
];

const location = getAndParseLocationCookie();

export function useShowNekoLens({ patientId }: { patientId: string }): boolean {
  const { stageType: environment } = useConfig();
  const { data: patientData } = usePatientQuery({ patientId });

  if (environment === "development") {
    return true;
  }

  return (
    NekoLensSiteIds.includes(location?.siteId ?? "") &&
    NekoLensSupportedPatientGroups.some(
      (value) => patientData?.groupIds.includes(value) ?? false
    )
  );
}
